import CrehanaLogo from '@crehana/icons/CrehanaLogo';
import { Container } from '@crehana/ui';

const Header = () => {
  return (
    <Container className="py-16 flex justify-center md:justify-start mb-64 sm:mb-80 md:py-24">
      <CrehanaLogo color="#FFF" size={24} />
    </Container>
  );
};

export default Header;
